module.exports = __webpack_public_path__ + "img/undraw_receipt_re_fre3.dce48aa6.svg";